<template>
  <div>
    <common-dialog ref="dialog" title="广告区域设置" width="1200px" :in-dialog="inDialog">
      <template slot="form">
        <list ref="list">
          <template slot="toolbar-right">
            <el-button size="mini" type="primary" v-if="$permission.canWrite()" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button size="mini" type="danger" v-if="$permission.canDel()" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{row}">
                <el-button type="text" icon="el-icon-edit" @click="edit(row)"></el-button>
                <el-button type="text" icon="el-icon-delete" @click="del(row.RecordId)" v-if="$permission.canDel()"></el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </template>
      <template slot="footer">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd"; //加载默认函数
import listDialogMixins from "@/mixins/listDialog";
import commonDialog from "@/components/common/dialog";
import list from "@/components/store/mallsectionad/list";
import editDialog from "@/components/store/mallsectionad/editDialog";

export default {
  mixins: [curdMixins, listDialogMixins],
  components: {
    commonDialog,
    list,
    editDialog,
  },
  data() {
    return {
      SectionId:null
    };
  },
  methods: {
    reload() {
      //这个的作用是执行 添加/编辑/删除 操作后刷新列表
      //弹窗没打开之前，这个list是undefined，所以需要加判断
      if (this.$refs.list) this.$refs.list.reload();
    },
    getData(params) {
      console.log("par", params);
      this.SectionId=params.SectionId;
      this.$refs.list.getData(params);
    },
    create(){
      this.$refs.editDialog.openCreate({SectionId:this.SectionId});
    },
    
    del(id) {
      //点删除按钮提示缺少delete-func属性，是因为mixins中默认有del方法，那个方法需要在列表传一个删除的api
      //可以自己写一个覆盖掉默认的
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => { });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RecordId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>